export default __webpack_public_path__ + "static/media/body-front.22cdaf58.png";